<script>
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import swal from "sweetalert";
export default {
  data() {
    return {
      submitted: false,
      showPassword: false,
      showConfirmPassword: false,
      user: {
        email: "",
        otp: "",
        password: "",
        confirmPassword: "",
      },
    };
  },

  created() {
    document.body.classList.add("auth-body-bg");
    // Get email from route params if available
    if (this.$route.params.email) {
      this.user.email = this.$route.params.email;
    }
  },

  validations: {
    user: {
      email: { required },
      otp: { required },
      password: { required, minLength: minLength(6) },
      confirmPassword: { required, sameAsPassword: sameAs("password") },
    },
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },

    reset() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const url = `${process.env.VUE_APP_BASE_URL}/auth/update-password`;
        this.$http
          .post(url, {
            email: this.user.email,
            password: this.user.password,
            confirmPassword: this.user.confirmPassword,
            otp: parseInt(this.user.otp),
            authorizationType: "admin-authentication",
          })
          .then((res) => {// eslint-disable-line no-unused-vars
            swal(
              "Successful!",
              "Password reset successfully! You can login now.",
              "success"
            ).then((res) => {// eslint-disable-line no-unused-vars
              this.$router.push("/login");
            });
          })
          .catch((err) => {// eslint-disable-line no-unused-vars
            swal(
              "Error!",
              "Failed to reset password. Please check your OTP and try again.",
              "error"
            );
            this.submitted = false;
          });
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4 m-auto">
            <div
              class="authentication-page-content p-4 d-flex align-items-center min-vh-100"
            >
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <img
                              src="../../../assets/xefe.png"
                              height="170"
                              alt="logo"
                            />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">Reset Password</h4>
                        <h4 class="font-size-24 mt-4">Admin Dashboard</h4>
                        <p class="text-muted">
                          Enter the OTP sent to your email and create a new
                          password.
                        </p>
                      </div>

                      <div class="p-2 mt-5">
                        <form class="form-horizontal" @submit.prevent="reset()">
                          <div class="form-group auth-form-group-custom mb-2">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="email">Email Address</label>
                            <input
                              v-model="user.email"
                              type="email"
                              class="form-control"
                              id="email"
                              placeholder="Enter your email address"
                              :class="{
                                'is-invalid': submitted && $v.user.email.$error,
                              }"
                            />
                            <div
                              v-if="submitted && $v.user.email.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.user.email.required"
                                >Email is required.</span
                              >
                            </div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-2">
                            <i class="ri-key-line auti-custom-input-icon"></i>
                            <label for="otp">OTP Code</label>
                            <input
                              v-model="user.otp"
                              type="text"
                              class="form-control"
                              id="otp"
                              placeholder="Enter OTP code from email"
                              :class="{
                                'is-invalid': submitted && $v.user.otp.$error,
                              }"
                            />
                            <div
                              v-if="submitted && $v.user.otp.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.user.otp.required"
                                >OTP is required.</span
                              >
                            </div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-2">
                            <i
                              class="ri-lock-2-line auti-custom-input-icon"
                            ></i>
                            <label for="password">New Password</label>
                            <input
                              v-model="user.password"
                              :type="showPassword ? 'text' : 'password'"
                              class="form-control"
                              id="password"
                              placeholder="Enter new password"
                              :class="{
                                'is-invalid':
                                  submitted && $v.user.password.$error,
                              }"
                              style="padding-right: 40px"
                            />
                            <i
                              :class="
                                showPassword ? 'ri-eye-off-line' : 'ri-eye-line'
                              "
                              @click="togglePasswordVisibility"
                              style="
                                position: absolute;
                                right: 12px;
                                top: 50%;
                                transform: translateY(-50%);
                                cursor: pointer;
                                color: #6c757d;
                                font-size: 16px;
                                margin-top: 15px;
                              "
                            ></i>
                            <div
                              v-if="submitted && $v.user.password.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.user.password.required"
                                >Password is required.</span
                              >
                              <span v-if="!$v.user.password.minLength"
                                >Password must be at least 6 characters.</span
                              >
                            </div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-4">
                            <i
                              class="ri-lock-2-line auti-custom-input-icon"
                            ></i>
                            <label for="confirmPassword"
                              >Confirm Password</label
                            >
                            <input
                              v-model="user.confirmPassword"
                              :type="showConfirmPassword ? 'text' : 'password'"
                              class="form-control"
                              id="confirmPassword"
                              placeholder="Confirm your new password"
                              :class="{
                                'is-invalid':
                                  submitted && $v.user.confirmPassword.$error,
                              }"
                              style="padding-right: 40px"
                            />
                            <i
                              :class="
                                showConfirmPassword
                                  ? 'ri-eye-off-line'
                                  : 'ri-eye-line'
                              "
                              @click="toggleConfirmPasswordVisibility"
                              style="
                                position: absolute;
                                right: 12px;
                                top: 50%;
                                transform: translateY(-50%);
                                cursor: pointer;
                                color: #6c757d;
                                font-size: 16px;
                                margin-top: 15px;
                              "
                            ></i>
                            <div
                              v-if="submitted && $v.user.confirmPassword.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.user.confirmPassword.required"
                                >Confirm password is required.</span
                              >
                              <span
                                v-if="!$v.user.confirmPassword.sameAsPassword"
                                >Passwords do not match.</span
                              >
                            </div>
                          </div>

                          <div class="mt-4 text-center">
                            <button
                              class="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                            >
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                                v-if="submitted == true"
                              ></span>
                              Reset Password
                            </button>
                          </div>

                          <div class="mt-4 text-center">
                            <router-link to="/login" class="text-muted">
                              <i class="mdi mdi-arrow-left mr-1"></i> Back to
                              Login
                            </router-link>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
